export const appConfig = {
  env: process.env.NODE_ENV || "development",
  debug: process.env.DEBUG === "true",
  app: {
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL || "https://tuyensinhnew.hub.edu.vn",
  },
  auth: {
    url: process.env.NEXTAUTH_URL || "",
  },
  api: {
    /** URL public API (client-side) */
    publicUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:3002/api",
    /** URL server API (server-side, internal network) */
    serverUrl: process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || "http://localhost:3002/api",
  },
} as const
